import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MDDialog({
  title,
  details,
  onAgree,
  customButton, // JSX element for the custom button
}) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgree = () => {
    onAgree();
    handleClose();
  };

  return (
    <MDBox>
      <div onClick={handleOpen}>{customButton}</div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          sx={{ padding: 5 }}
        >
          <DialogTitle id="responsive-dialog-title">
            <MDTypography
              variant="h6"
              color="white"
              fontWeight="medium"
              textTransform="capitalize"
            >
              {title}
            </MDTypography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <MDTypography variant="button" fontWeight="regular" color="white">
                {details}
              </MDTypography>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <MDButton onClick={handleClose}>Disagree</MDButton>
            <MDButton onClick={handleAgree}>Agree</MDButton>
          </DialogActions>
        </MDBox>
      </Dialog>
    </MDBox>
  );
}
